var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',{staticClass:"grey lighten-4 white--text",staticStyle:{"height":"150px","position":"sticky","top":"80px","z-index":"1","overflow":"hidden auto","box-shadow":"0 0 black"}},[_c('OrderListItem',{attrs:{"order":{
      seller: {
        order_ref: '0001',
        name: 'George'
      },
      pickup: {
        date: '2019-07-01',
        address: 'Brno'
      },
      buyer: {
        order_ref: '0001_buyer',
        name: 'Nikos'
      },
      delivery: {
        date: '2019-07-16',
        address: 'Prague'
      },
      weight: 10,
      volume: 3,
      packages: 1,
      status: _vm.statusChanging
    }}})],1),_c('v-card-text',[_c('v-timeline',{attrs:{"dense":"","clipped":""}},[(_vm.getResults.length > 0 && _vm.toggleView === 'Time')?_vm._l((_vm.getResults),function(event){return _c('v-timeline-item',{key:event.id + '_key',attrs:{"color":_vm.colorPerEvent(event.eventType),"fill-dot":"","left":"","small":""}},[_c('v-row',{attrs:{"justify":"space-between"}},[_c('v-col',{attrs:{"cols":"7"}},[_c('v-card',{staticClass:"white--text",class:_vm.colorPerEvent(event.eventType),attrs:{"avatar":"","ripple":""},on:{"click":function($event){}}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(event.actor.split(':')[1]))]),_c('span',[_vm._v(_vm._s(event.eventType))])])])],1)],1),_c('v-col',{staticClass:"text-right",attrs:{"cols":"5"}},[_vm._v(_vm._s(event.eventTime))])],1)],1)}):_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"width":7,"size":70,"color":"red","indeterminate":""}})],1)],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }